import { useQuery } from "@tanstack/react-query";
import { fetchPlaceDetails } from "../lib/api";

export function usePlaceDetails(placeId: string | null | undefined) {
  return useQuery({
    queryKey: ["place-details", placeId],
    queryFn: () => fetchPlaceDetails(placeId as string),
    enabled: !!placeId,
    staleTime: 1000 * 60 * 60 * 24 * 7,
  });
}
